// import { useState, useEffect, useMemo } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import lodash from "lodash";

// // @mui material components
// import { ThemeProvider } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";
// import Icon from "@mui/material/Icon";

// // Material Dashboard 2 React components
// import MDBox from "components/MDBox";

// // Example components
// import Sidenav from "examples/Sidenav";
// import Configurator from "examples/Configurator";

// // Themes
// import theme from "assets/theme";
// import themeRTL from "assets/theme/theme-rtl";
// import themeDark from "assets/theme-dark";
// import themeDarkRTL from "assets/theme-dark/theme-rtl";

// // RTL
// import rtlPlugin from "stylis-plugin-rtl";
// import { CacheProvider } from "@emotion/react";
// import createCache from "@emotion/cache";

// // Toast
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // Redux
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAccount } from "features/accounts/accountThunk";

// // Routes
// import routes from "routes";

// // Context
// import {
//   useMaterialUIController,
//   setMiniSidenav,
//   setOpenConfigurator,
// } from "context";

// // Images
// import brandWhite from "assets/images/dhundhoo_logo.png";
// import brandDark from "assets/images/logo-ct-dark.png";

// export default function App() {
//   const [controller, dispatch] = useMaterialUIController();
//   const {
//     miniSidenav,
//     direction,
//     layout,
//     openConfigurator,
//     sidenavColor,
//     transparentSidenav,
//     whiteSidenav,
//     darkMode,
//   } = controller;

//   const [onMouseEnter, setOnMouseEnter] = useState(false);
//   const [rtlCache, setRtlCache] = useState(null);
//   const { pathname } = useLocation();
//   const dispatchs = useDispatch();

//   const { data, loading, error } = useSelector((state) => state.account);

//   // Sync localStorage with data.orgInfo whenever it changes
//   useEffect(() => {
//     if (data?.orgInfo) {
//       localStorage.setItem("role", data.orgInfo.role || "");
//       localStorage.setItem("orgtype", data.orgInfo.orgHandle || "");
//       localStorage.setItem("orgName", data.orgInfo.orgName || "");
//       if (data.orgInfo.things?.[0]) {
//         localStorage.setItem("customertype", data.orgInfo.things[0]);
//       }
//     }
//   }, [data?.orgInfo]);

//   // Fetch account on mount
//   useEffect(() => {
//     dispatchs(fetchAccount());
//   }, [dispatchs]);

//   // RTL Cache
//   useMemo(() => {
//     const cacheRtl = createCache({
//       key: "rtl",
//       stylisPlugins: [rtlPlugin],
//     });
//     setRtlCache(cacheRtl);
//   }, []);

//   // Sidenav hover handlers
//   const handleOnMouseEnter = () => {
//     if (miniSidenav && !onMouseEnter) {
//       setMiniSidenav(dispatch, false);
//       setOnMouseEnter(true);
//     }
//   };

//   const handleOnMouseLeave = () => {
//     if (onMouseEnter) {
//       setMiniSidenav(dispatch, true);
//       setOnMouseEnter(false);
//     }
//   };

//   const handleConfiguratorOpen = () =>
//     setOpenConfigurator(dispatch, !openConfigurator);

//   // Set direction
//   useEffect(() => {
//     document.body.setAttribute("dir", direction);
//   }, [direction]);

//   // Scroll to top on route change
//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//     if (document.scrollingElement) {
//       document.scrollingElement.scrollTop = 0;
//     }
//   }, [pathname]);

//   // Dynamic route filtering based on role, config, and permissions
//   const filteredRoutes = useMemo(() => {
//     if (!data?.orgInfo) {
//       return routes.filter((r) => r.id === "1");
//     }

//     const role = data.orgInfo.role;
//     const orgtype = data.orgInfo.orgHandle;
//     const orgVendor = data.orgInfo.vendorHandle
//     const orgName = data.orgInfo.orgName;
//     const configOptions = data.orgInfo.config || {};
//     const isDemo = window.localStorage.getItem("dhundhoo-demo") === "true";

//     // window.localStorage.setItem("orgVendor", orgVendor);

//     // Base permissions
//     let permissionsVisit = ["29"];

//     if (isDemo) {
//       permissionsVisit = ["9", "144", "7", "4", "29"];
//     } else if (orgtype === "eba4b512-3999-46e1-bc68-6d5db50e977d") {
//       permissionsVisit = [
//         "1", "6", "62", "16", "7", "102", "14", "141", "146", "147", "148",
//         "149", "150", "151", "4", "152", "153", "154", "66", "155", "156",
//         "200", "29"
//       ];
//     } else if (role === "ADMIN") {
//       permissionsVisit = [
//         "1", "3", "2", "6", "4", "5", "16", "19", "25", "26", "27", "28", "62", "7", "102", "14", "141",
//         "142", "146", "147", "148", "75", "76", "77", "149", "150", "191", "192", "193",
//         "23", "195", "24", "196", "197", "151", "152", "153", "154", "198",
//         "194", "155", "156", "199", "200", "201", "29"
//       ];
//     } else if (role === "All Features") {
//       permissionsVisit = [
//         "1", "6", "4", "16", "62", "7", "102", "14", "141", "146", "147",
//         "148", "149", "150", "192", "193", "23", "196", "197",
//         "151", "152", "154", "198", "155", "156", "157", "200", "29"
//       ];
//     } else if (role === "Only Dashboard") {
//       permissionsVisit = ["1"];
//     } else {
//       permissionsVisit = [
//         "1", "6", "16","19", "62","65","66","67","68", "7", "14","102", "141", "146", "147",
//         "148", "149", "151", "4", "152", "153", "154","199", "999", "155", "156",
//         "157","200", "29"
//       ];
//     }

//     if (data.orgInfo.type === "ORG_SCHOOL") {
//       permissionsVisit.push("63", "142");
//     }

//     // Feature flags from config
//     const isAttendance = configOptions.attendance_option === "ENABLED";
//     const isCamera = configOptions.camera_option === "ENABLED";
//     const isManagement = configOptions.management === "ENABLED";
//     const isAlerts = configOptions.alert === "ENABLED";
//     const isPlanning = configOptions.planning === "ENABLED";
//     const isTripDetails = configOptions.trip === "ENABLED";
//     const isWallet = configOptions.wallet === "ENABLED";
//     const isJobRole = configOptions.jobRole === "ENABLED";
//     const isLiveCamera = configOptions.liveCamera === "ENABLED";
//     const isFuelLog = configOptions.fuelLog === "ENABLED";
//     const isrouteOptimization = configOptions.routeOptimization === "ENABLED";

//     localStorage.setItem("isWallet", isWallet ? 'true' : 'false');
//     localStorage.setItem("isLiveCamera", isLiveCamera ? "true" : "false");

//     const extraPermissions = [];

//     if (isAttendance) extraPermissions.push("144");
//     if (isManagement) extraPermissions.push("24", "62", "196", "197");
//     if (isAlerts) extraPermissions.push( "191","195");
//     if (isPlanning) extraPermissions.push("17");
//     if (isCamera) extraPermissions.push("18");
//     if (isTripDetails) extraPermissions.push("65");
//     if (isJobRole) extraPermissions.push("5", "75", "76", "77");
//     if (isFuelLog) extraPermissions.push("25", "26", "27", "28");
//     if (isWallet) extraPermissions.push("160", "161", "162", "163", "164");
//     if (isLiveCamera) extraPermissions.push("6");
//     if (isrouteOptimization) extraPermissions.push("69");
//     if (orgName === "Dhundhoo System") {
//       extraPermissions.push("5", "17", "12", "20", "24", "25", "26", "27", "28", "62","65","66","67","68", "69", "75", "76", "77", "100", "101","102", "103", "122","191","195","196", "197");
//     }
//     if (!isDemo && lodash.size(orgVendor) < 1 && data.orgInfo.type === "ORG_SCHOOL") {
//       extraPermissions.push("12", "64", "122");
//     }

//     // Deduplicate all permissions
//   const finalPermissions = lodash.uniq([...permissionsVisit, ...extraPermissions]);

//   // 5. Recursive Filtering Function
//   const filterRecursive = (routeList) => {
//     return routeList
//       .filter((route) => {
//         const idStr = route.id?.toString();
//         const mpidStr = route.mpid?.toString();
//         const bpidStr = route.bpid?.toString();

//         // Check ID permission
//         const idCheck = idStr ? finalPermissions.includes(idStr) : true;
//         // Check Master Parent permission
//         const mpidCheck = mpidStr ? (finalPermissions.includes(mpidStr) || mpidStr === "-1") : true;
//         // Check Base Parent permission
//         const bpidCheck = bpidStr ? finalPermissions.includes(bpidStr) : true;

//         // Force Dashboard visibility, otherwise validate checks
//         return route.id === "1" || (idCheck && mpidCheck && bpidCheck);
//       })
//       .map((route) => {
//         // If this route has a sub-menu (collapse), filter it recursively
//         if (route.collapse) {
//           return {
//             ...route,
//             collapse: filterRecursive(route.collapse),
//           };
//         }
//         return route;
//       })
//       // Optional: Remove parent menus if they have no visible children left
//       .filter((route) => route.id === "1" || !route.collapse || route.collapse.length > 0);
//   };

//   console.log("routes",routes);


//   return filterRecursive(routes);
// }, [data, routes]);



//   // Recursive route generator
//   const getRoutes = (allRoutes) =>
//     allRoutes.map((route) => {
//       if (route.collapse) {
//         return getRoutes(route.collapse);
//       }
//       if (route.route) {
//         return (
//           <Route
//             exact
//             path={route.route}
//             element={route.component}
//             key={route.key}
//           />
//         );
//       }
//       return null;
//     });

//   // Configurator button
//   const configsButton = (
//     <MDBox
//       display="none"
//       justifyContent="center"
//       alignItems="center"
//       width="3.25rem"
//       height="3.25rem"
//       bgColor="white"
//       shadow="sm"
//       borderRadius="50%"
//       position="fixed"
//       right="2rem"
//       bottom="2rem"
//       zIndex={99}
//       color="dark"
//       sx={{ cursor: "pointer" }}
//       onClick={handleConfiguratorOpen}
//     >
//       <Icon fontSize="small" color="inherit">
//         settings
//       </Icon>
//     </MDBox>
//   );

//   const live_pages = ["/live", "/live_ol_google", "/live_singletrack", "/live_lite", "/live_temp"];
//   const isStandaloneRoute = live_pages.includes(pathname);

//   const hasToken = !!localStorage.getItem("token");
//   const isAuthPage = pathname.includes("/authentication");

//   // Redirect to sign-in if no session and not already on auth page
//   if (!hasToken && !isAuthPage) {
//     return <Navigate to="/authentication/sign-in" replace />;
//   }

//   // Standalone live pages (no sidebar)
//   if (isStandaloneRoute) {
//     return (
//       <ThemeProvider theme={darkMode ? themeDark : theme}>
//         <CssBaseline />
//         <Routes>
//           {getRoutes(routes)}
//           <Route path="*" element={<Navigate to="/live" />} />
//         </Routes>
//         <ToastContainer />
//       </ThemeProvider>
//     );
//   }

//   // RTL Layout
//   if (direction === "rtl") {
//     return (
//       <CacheProvider value={rtlCache}>
//         <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
//           <CssBaseline />
//           {layout === "dashboard" && (
//             <>
//               <Sidenav
//                 color={sidenavColor}
//                 brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
//                 brandName="Dhundhoo"
//                 routes={filteredRoutes}
//                 onMouseEnter={handleOnMouseEnter}
//                 onMouseLeave={handleOnMouseLeave}
//               />
//               <Configurator />
//               {configsButton}
//             </>
//           )}
//           {layout === "vr" && <Configurator />}
//           <Routes>
//             {getRoutes(routes)}
//             <Route
//               path="*"
//               element={<Navigate to={hasToken ? "/Live-Map" : "/authentication/sign-in"} />}
//             />          </Routes>
//           <ToastContainer />
//         </ThemeProvider>
//       </CacheProvider>
//     );
//   }

//   // LTR Layout (Default)
//   return (
//     <>
//       <ThemeProvider theme={darkMode ? themeDark : theme}>
//         <CssBaseline />
//         {layout === "dashboard" && (
//           <>
//             <Sidenav
//               color={sidenavColor}
//               brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
//               brandName="Dhundhoo"
//               routes={filteredRoutes}
//               onMouseEnter={handleOnMouseEnter}
//               onMouseLeave={handleOnMouseLeave}
//             />
//             <Configurator />
//             {configsButton}
//           </>
//         )}
//         {layout === "vr" && <Configurator />}
//         <Routes>
//           {getRoutes(routes)}
//           <Route
//             path="*"
//             element={<Navigate to={hasToken ? "/Live-Map" : "/authentication/sign-in"} />}
//           />      </Routes>
//         <ToastContainer />
//       </ThemeProvider>
//     </>
//   );
// }

import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import lodash from "lodash";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { fetchAccount } from "features/accounts/accountThunk";

// Routes
import routes from "routes";

// 404 / access-denied page
import Error404 from "layouts/authentication/error-404";

// Context
import {
  useMaterialUIController,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

// Images
import brandWhite from "assets/images/dhundhoo_logo.png";
import brandDark from "assets/images/logo-ct-dark.png";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;

  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const dispatchs = useDispatch();

  const { data, loading, error } = useSelector((state) => state.account);

  // Sync localStorage with data.orgInfo whenever it changes
  useEffect(() => {
    if (data?.orgInfo) {
      localStorage.setItem("role", data.orgInfo.role || "");
      localStorage.setItem("orgtype", data.orgInfo.orgHandle || "");
      localStorage.setItem("orgName", data.orgInfo.orgName || "");
      if (data.orgInfo.things?.[0]) {
        localStorage.setItem("customertype", data.orgInfo.things[0]);
      }
    }
  }, [data?.orgInfo]);

  // Fetch account on mount
  useEffect(() => {
    dispatchs(fetchAccount());
  }, [dispatchs]);

  // RTL Cache
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });
    setRtlCache(cacheRtl);
  }, []);

  // Sidenav hover handlers
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);

  // Set direction
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Scroll to top on route change
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname]);

  // Dynamic route filtering based on role, config, and permissions
  // const filteredRoutes = useMemo(() => {
  //   if (!data?.orgInfo) {
  //     // Before login/account-fetch we still need the dashboard route (id "1")
  //     // as a landing target and the sign-in route (id "29") so the
  //     // sign-in page itself can render.
  //     return routes.filter((r) => r.id === "1" || r.id === "29");
  //   }

  //   const role = data.orgInfo.role;
  //   const orgtype = data.orgInfo.orgHandle;
  //   const orgVendor = data.orgInfo.vendorHandle;
  //   const orgName = data.orgInfo.orgName;
  //   const configOptions = data.orgInfo.config || {};
  //   const isDemo = window.localStorage.getItem("dhundhoo-demo") === "true";

  //   console.log("role", role);


  //   // Base permissions
  //   let permissionsVisit = ["29"];

  //   if (isDemo) {
  //     permissionsVisit = ["9", "144", "7", "4", "29"];
  //   } else if (orgtype === "eba4b512-3999-46e1-bc68-6d5db50e977d") {
  //     permissionsVisit = [
  //       "1", "6", "62", "16", "7", "102", "14", "141", "146", "147", "148",
  //       "149", "150", "151", "4", "152", "153", "154", "66", "155", "156",
  //       "200", "29"
  //     ];
  //   } else if (role === "ADMIN") {
  //     permissionsVisit = [
  //       "1", "3", "2", "6", "4", "5", "16", "19", "25", "26", "27", "28", "62", "7", "102", "14", "141",
  //       "142", "146", "147", "148", "75", "76", "77", "149", "150", "191", "192", "193",
  //       "23", "195", "24", "196", "197", "151", "152", "153", "154", "198",
  //       "194", "155", "156", "199", "200", "201", "29"
  //     ];
  //   } else if (role === "All Features") {
  //     permissionsVisit = [
  //       "1", "6", "4", "16", "62", "7", "102", "14", "141", "146", "147",
  //       "148", "149", "150", "192", "193", "23", "196", "197",
  //       "151", "152", "154", "198", "155", "156", "157", "200", "29"
  //     ];
  //   } else if (role === "Only Dashboard") {
  //     permissionsVisit = ["1"];
  //   } else {
  //     permissionsVisit = [
  //       "1", "6", "16", "19", "62", "65", "66", "67", "68", "7", "14", "102", "141", "146", "147",
  //       "148", "149", "151", "4", "152", "153", "154", "199", "999", "155", "160", "161", "156",
  //       "157", "200", "29", "214", "210", "170"
  //     ];
  //   }

  //   if (data.orgInfo.type === "ORG_SCHOOL") {
  //     permissionsVisit.push("63", "142");
  //   }

  //   // Feature flags from config
  //   const isAttendance = configOptions.attendance_option === "ENABLED";
  //   const isCamera = configOptions.camera_option === "ENABLED";
  //   const isManagement = configOptions.management === "ENABLED";
  //   const isAlerts = configOptions.alert === "ENABLED";
  //   const isPlanning = configOptions.planning === "ENABLED";
  //   const isTripDetails = configOptions.trip === "ENABLED";
  //   const isWallet = configOptions.wallet === "ENABLED";
  //   const isJobRole = configOptions.jobRole === "ENABLED";
  //   const isLiveCamera = configOptions.liveCamera === "ENABLED";
  //   const isFuelLog = configOptions.fuelLog === "ENABLED";
  //   const isrouteOptimization = configOptions.routeOptimization === "ENABLED";

  //   localStorage.setItem("isWallet", isWallet ? "true" : "false");
  //   localStorage.setItem("isLiveCamera", isLiveCamera ? "true" : "false");

  //   const extraPermissions = [];

  //   if (isAttendance) extraPermissions.push("144");
  //   if (isManagement) extraPermissions.push("24", "62", "196", "197");
  //   if (isAlerts) extraPermissions.push("191", "195");
  //   if (isPlanning) extraPermissions.push("17");
  //   if (isCamera) extraPermissions.push("18");
  //   if (isTripDetails) extraPermissions.push("65");
  //   if (isJobRole) extraPermissions.push("5", "75", "76", "77");
  //   if (isFuelLog) extraPermissions.push("25", "26", "27", "28");
  //   if (isWallet) extraPermissions.push("160", "161", "162", "163", "164");
  //   if (isLiveCamera) extraPermissions.push("6");
  //   if (isrouteOptimization) extraPermissions.push("69");
  //   if (orgName === "Dhundhoo System") {
  //     extraPermissions.push(
  //       "5", "17", "12", "20", "24", "25", "26", "27", "28", "62", "65", "66", "67", "68",
  //       "69", "75", "76", "77", "100", "101", "102", "103", "104", "122", "160", "161", "191", "195", "196", "197", "202", "211", "212", "213"
  //     );
  //   }
  //   if (!isDemo && lodash.size(orgVendor) < 1 && data.orgInfo.type === "ORG_SCHOOL") {
  //     extraPermissions.push("12", "64", "122");
  //   }

  //   // Deduplicate all permissions
  //   const finalPermissions = lodash.uniq([...permissionsVisit, ...extraPermissions]);

  //   // Recursive Filtering Function
  //   const filterRecursive = (routeList) => {
  //     return routeList
  //       .filter((route) => {
  //         const idStr = route.id?.toString();
  //         const mpidStr = route.mpid?.toString();
  //         const bpidStr = route.bpid?.toString();

  //         // Check ID permission
  //         const idCheck = idStr ? finalPermissions.includes(idStr) : true;
  //         // Check Master Parent permission
  //         const mpidCheck = mpidStr ? (finalPermissions.includes(mpidStr) || mpidStr === "-1") : true;
  //         // Check Base Parent permission
  //         const bpidCheck = bpidStr ? finalPermissions.includes(bpidStr) : true;

  //         // Force Dashboard visibility, otherwise validate checks
  //         return route.id === "1" || (idCheck && mpidCheck && bpidCheck);
  //       })
  //       .map((route) => {
  //         // If this route has a sub-menu (collapse), filter it recursively
  //         if (route.collapse) {
  //           return {
  //             ...route,
  //             collapse: filterRecursive(route.collapse),
  //           };
  //         }
  //         return route;
  //       })
  //       // Remove parent menus if they have no visible children left
  //       .filter((route) => route.id === "1" || !route.collapse || route.collapse.length > 0);
  //   };

  //   return filterRecursive(routes);
  // }, [data, routes]);

  // Dynamic route filtering based on role, config, and permissions
  const filteredRoutes = useMemo(() => {
    if (!data?.orgInfo) {
      return routes.filter((r) => r.id === "1" || r.id === "29");
    }

    // LocalStorage se naya API wala role uthayein (agar nahi mila to normal backend wala)
    const role = localStorage.getItem("userRole") || data.orgInfo.role;
    const orgtype = data.orgInfo.orgHandle;
    const orgVendor = data.orgInfo.vendorHandle;
    const orgName = data.orgInfo.orgName;
    const configOptions = data.orgInfo.config || {};
    const isDemo = window.localStorage.getItem("dhundhoo-demo") === "true";

    // Base permissions (For other unspecified roles)
    let permissionsVisit = ["29"];

    if (isDemo) {
      permissionsVisit = ["9", "144", "7", "4", "29"];
    } else if (orgtype === "eba4b512-3999-46e1-bc68-6d5db50e977d") {
      permissionsVisit = [
        "1", "6", "62", "16", "7", "102", "14", "141", "146", "147", "148",
        "149", "150", "151", "4", "152", "153", "154", "66", "155", "156",
        "200", "29"
      ];
    } else {
      permissionsVisit = [
        "1", "6", "16", "19", "24", "62", "65", "66", "67", "68", "7", "14", "102", "141", "146", "147",
        "148", "149", "151", "4", "152", "153", "154", "196", "197", "199", "999", "155", "160", "161", "156",
        "157", "200", "29", "214", "210", "170"
      ];
    }

    if (data.orgInfo.type === "ORG_SCHOOL") {
      permissionsVisit.push("63", "142");
    }

    // Feature flags from config
    const isAttendance = configOptions.attendance_option === "ENABLED";
    const isCamera = configOptions.camera_option === "ENABLED";
    const isManagement = configOptions.management === "ENABLED";
    const isAlerts = configOptions.alert === "ENABLED";
    const isPlanning = configOptions.planning === "ENABLED";
    const isTripDetails = configOptions.trip === "ENABLED";
    const isWallet = configOptions.wallet === "ENABLED";
    const isJobRole = configOptions.jobRole === "ENABLED";
    const isLiveCamera = configOptions.liveCamera === "ENABLED";
    const isFuelLog = configOptions.fuelLog === "ENABLED";
    const isrouteOptimization = configOptions.routeOptimization === "ENABLED";

    localStorage.setItem("isWallet", isWallet ? "true" : "false");
    localStorage.setItem("isLiveCamera", isLiveCamera ? "true" : "false");

    const extraPermissions = [];

    if (isAttendance) extraPermissions.push("144");
    if (isManagement) extraPermissions.push("24", "62", "196", "197");
    if (isAlerts) extraPermissions.push("191", "195");
    if (isPlanning) extraPermissions.push("17");
    if (isCamera) extraPermissions.push("18");
    if (isTripDetails) extraPermissions.push("65");
    if (isJobRole) extraPermissions.push("5", "75", "76", "77");
    if (isFuelLog) extraPermissions.push("25", "26", "27", "28");
    if (isWallet) extraPermissions.push("160", "161", "162", "163", "164");
    if (isLiveCamera) extraPermissions.push("6");
    if (isrouteOptimization) extraPermissions.push("69");

    // Ye block upar tha pehle jo error de sakta tha, ise yahan sahi jagah rakha hai
    if (orgName === "Dhundhoo System") {
      extraPermissions.push(
        "5", "17", "12", "20", "24", "25", "26", "27", "28", "62", "65", "66", "67", "68",
        "69", "75", "76", "77", "100", "101", "102", "103", "104", "122", "160", "161", "191", "195", "196", "197", "202", "211", "212", "213"
      );
    }
    if (!isDemo && lodash.size(orgVendor) < 1 && data.orgInfo.type === "ORG_SCHOOL") {
      extraPermissions.push("12", "64", "122");
    }

    // Deduplicate all permissions
    const finalPermissions = lodash.uniq([...permissionsVisit, ...extraPermissions]);

    // Recursive Filtering Function
    const filterRecursive = (routeList) => {
      return routeList
        .filter((route) => {
          const idStr = route.id?.toString();
          const mpidStr = route.mpid?.toString();
          const bpidStr = route.bpid?.toString();

          if (orgName === "Dhundhoo System") {
            const systemIds = [
              "1", "14", "29",
              "5", "17", "12", "20", "24", "25", "26", "27", "28", "62", "65", "66", "67", "68",
              "69", "75", "76", "77", "100", "101", "102", "103", "104", "122", "160", "161", "191",
              "195", "154", "196", "197", "202", "211", "212", "213", "214", "210",
            ];

            if (systemIds.includes(idStr) || systemIds.includes(bpidStr) || systemIds.includes(mpidStr)) {
              return true;
            }
            return false; // Inke alawa baki sab hide
          }

          // 1. "Only Dashboard": Sirf Live Map (1) and SignIn (29) allow hoga
          if (role === "Only Dashboard") {
            return idStr === "1" || idStr === "29";
          }

          // 2. "All Features": Sirf Live Map, Route Replay, Reports, Alerts (aur Sign In) allow hoga
          if (role === "All Features") {
            // Explicitly 191 aur 195 ko hide karo
            if (idStr === "191" || idStr === "195") {
              return false;
            }

            const allowedIds = ["1", "7", "14", "19", "29", "170", "161", "154", "160", "210", "214"];
            // Parent IDs ke basis pe baki ko allow karo (jaise 199 automatically dikh jayega)
            if (allowedIds.includes(idStr) || allowedIds.includes(bpidStr) || allowedIds.includes(mpidStr)) {
              return true;
            }
            return false;
          }

          if (role === "Admin") {
            const blockedIds = ["20", "24","28", "62", "196", "197"];

            if (blockedIds.includes(idStr) || blockedIds.includes(bpidStr) || blockedIds.includes(mpidStr)) {
              return false;
            }
            return true;
          }

          // -------------------------------------------------------------

          // Default verification (Agar upar me se koi role/org nahi hai tab)
          const idCheck = idStr ? finalPermissions.includes(idStr) : true;
          const mpidCheck = mpidStr ? (finalPermissions.includes(mpidStr) || mpidStr === "-1") : true;
          const bpidCheck = bpidStr ? finalPermissions.includes(bpidStr) : true;

          return route.id === "1" || (idCheck && mpidCheck && bpidCheck);
        })
        .map((route) => {
          if (route.collapse) {
            return {
              ...route,
              collapse: filterRecursive(route.collapse),
            };
          }
          return route;
        })
        .filter((route) => route.id === "1" || !route.collapse || route.collapse.length > 0);
    };

    return filterRecursive(routes);
  }, [data, routes]);

  // Recursive route generator
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }
      return null;
    });

  // Configurator button
  const configsButton = (
    <MDBox
      display="none"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );

  const live_pages = ["/live", "/live_ol_google", "/live_singletrack", "/live_lite", "/live_temp"];
  const isStandaloneRoute = live_pages.includes(pathname);

  const hasToken = !!localStorage.getItem("token");
  const isAuthPage = pathname.includes("/authentication");

  // IMPORTANT: standalone public live routes must be checked BEFORE the
  // token redirect, otherwise unauthenticated users get bounced to
  // sign-in instead of reaching the public live page.
  if (isStandaloneRoute) {
    return (
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        <CssBaseline />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/live" replace />} />
        </Routes>
        <ToastContainer />
      </ThemeProvider>
    );
  }

  // Redirect to sign-in if no session and not already on auth page
  if (!hasToken && !isAuthPage) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  // RTL Layout
  if (direction === "rtl") {
    return (
      <CacheProvider value={rtlCache}>
        <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
          <CssBaseline />
          {layout === "dashboard" && (
            <>
              <Sidenav
                color={sidenavColor}
                brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
                brandName="NAVYTIC"
                routes={filteredRoutes}
                onMouseEnter={handleOnMouseEnter}
                onMouseLeave={handleOnMouseLeave}
              />
              <Configurator />
              {configsButton}
            </>
          )}
          {layout === "vr" && <Configurator />}
          <Routes>
            {getRoutes(filteredRoutes)}
            <Route path="/" element={<Navigate to="/Live-Map" replace />} />
            <Route
              path="*"
              element={
                hasToken ? <Error404 /> : <Navigate to="/authentication/sign-in" replace />
              }
            />
          </Routes>
          <ToastContainer />
        </ThemeProvider>
      </CacheProvider>
    );
  }

  // LTR Layout (Default)
  return (
    <>
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="NAVYTIC"
              routes={filteredRoutes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(filteredRoutes)}
          <Route path="/" element={<Navigate to="/Live-Map" replace />} />
          <Route
            path="*"
            element={
              hasToken ? <Error404 /> : <Navigate to="/authentication/sign-in" replace />
            }
          />
        </Routes>
        <ToastContainer />
      </ThemeProvider>
    </>
  );
}